import axios from 'axios';

export function getStatisticsCargoRequests(from, until) {
    return axios({
        method: 'POST',
        url: '/api/v1/statistics/cargoRequests',
        data: {
            from,
            until,
        },
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}


// WEBPACK FOOTER //
// ./app/services/statistics/cargoRequests.js